export const environment = {
  graphqlUri: 'https://ges-reseau-gateway-api.int.finzzle-groupe.com/graphql',

  // INT
  // auth: {
  //   clientId: '2HPFjhlRI4.gestres',
  //   loginUrl: 'https://auth-int.prodemial.fr/cas/oauth2.0/authorize',
  //   logoutUrl: 'https://auth-int.prodemial.fr/cas/logout',
  //   tokenUrl: 'https://auth-int.prodemial.fr/cas/oauth2.0/token',
  // },

  // REC
  auth: {
    clientId: 'wNPaIMghee.gestres',
    loginUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/authorize',
    logoutUrl: 'https://reseau-rec.prodemial.fr/cas/logout',
    tokenUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/token',
  },

  roles: {
    shmAdGroups: ['APP_GESTION_RESEAU_RESP-HP', 'APP_GESTION_RESEAU_GEST-HP'],
    gcomAdGroups: ['APP_GESTION_RESEAU_GCOM_RESP-HP', 'APP_GESTION_RESEAU_GCOM_GEST-HP'],
  },
};
